import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ListiniApi, GetListiniAnimaliDettagliRequest, GetListiniPulciniRequest } from "../data/apis/ListiniApi";
import { useContext } from "react";
import FilieraContext from "../contexts/filieraContext";

export function listiniPulciniDataSource(idFiliera: number, showAll: boolean) {
    return new CustomStore({
        key: "id",
        loadMode : 'raw',
        load: (loadOptions) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListiniPulcini({
                idFiliera: idFiliera,
            });
        },

        byKey: (key) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListinoPulciniById({
                idListino: key
            });
        },

        insert: (values) => {
            const api = new ListiniApi(apiConfiguration);

            return api.insertListinoPulcini({
                listinoCreateDTO: values
            });
        },

        update: async (key: any) => {},
        remove: async (key: any) => {},
        
    });
}
